import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSite } from "@/context/SiteContext";

export const useSiteOpen = () => {
  const { user } = useAuth();
  const { launched } = useSite();
  if (launched === null || user === null) return null;
  return launched || !!user;
};

export const PrelaunchGate = ({ children }) => {
  const open = useSiteOpen();
  if (open === null) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="animate-spin text-qi-pink" /></div>;
  return open ? children : <Navigate to="/" replace />;
};
